import React from 'react';
import { Modal } from 'antd';
import {
  useCalendarActionPerformedState,
  useCalendarActionsData,
} from '../../../../services/calendarActionsProvider';
import { deletableCalendarEntityKeys } from '../../../../shared/configs/calendar';
import { useBlockDeleteIntervalSuccess } from '../../services/blockDeleteIntervalSuccess';
import { useDeleteCalendarIntervals } from '../../../../api/deleteCalendarIntervals';

const content = {
  [deletableCalendarEntityKeys.day]: {
    text: 'Удалить свободные интервалы всех столов',
    confirmTitle: 'Удаление интервалов',
    confirmText:
      'Вы уверены, что хотите удалить свободные интервалы всех столов?',
    createMutationProps: (props) => ({
      dateId: props.dateId,
      entity: deletableCalendarEntityKeys.day,
      errorMessage: 'Не удалось удалить интервалы',
    }),
  },
  [deletableCalendarEntityKeys.desk]: {
    text: 'Удалить свободные интервалы стола',
    confirmTitle: 'Удаление интервалов',
    confirmText: 'Вы уверены, что хотите удалить свободные интервалы стола?',
    createMutationProps: (props) => ({
      dateId: props.dateId,
      deskId: props.deskId,
      entity: deletableCalendarEntityKeys.desk,
      errorMessage: 'Не удалось удалить интервалы',
    }),
  },
  [deletableCalendarEntityKeys.interval]: {
    text: 'Удалить интервал',
    confirmTitle: 'Удаление интервала',
    confirmText: 'Вы уверены, что хотите удалить инетрвал?',
    createMutationProps: (props) => ({
      intervalId: props.intervalId,
      entity: deletableCalendarEntityKeys.interval,
      errorMessage: 'Не удалось удалить интервал',
    }),
  },
};

const DeleteCalendarIntervals = ({ deletableEntity }) => {
  const { text, confirmTitle, confirmText, createMutationProps } =
    content[deletableEntity];

  const onSuccess = useBlockDeleteIntervalSuccess();

  const { dateId, deskId, interval } = useCalendarActionsData();

  const [, setIsPerformed] = useCalendarActionPerformedState();

  const { mutateAsync } = useDeleteCalendarIntervals({ onSuccess });

  const execute = async () => {
    setIsPerformed(true);
    await mutateAsync(
      createMutationProps({ dateId, deskId, intervalId: interval?.id })
    );
    setIsPerformed(false);
  };

  const handleClick = () => {
    Modal.confirm({
      title: confirmTitle,
      content: confirmText,
      centered: true,
      onOk: execute,
      onCancel: () => {},
    });
  };

  return <div onClick={handleClick}>{text}</div>;
};

export default DeleteCalendarIntervals;
